export enum ViewLayoutStatus {
  Hide = 'hide',
  Show = 'show',
  Collapse = 'collapse'
}
